var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeviceMapIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "devicemap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 20.502
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-1-error-message",
    transform: "translate(-120.000000, -1037.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devicemap",
    transform: "translate(120.000000, 1037.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_170"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.060593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.005,9.06040658 L13.9,9.06040658 C13.7,9.42440658 13.488,9.78740658 13.281,10.1444066 L18.171,10.1444066 L20.595,19.3574066 L16.149,19.3574066 C16.1456941,16.6652844 13.9641222,14.4837125 11.272,14.4804066 L9.645,14.4804066 C8.1489937,14.4787532 6.93665335,13.2664129 6.935,11.7704066 L6.935,10.1444066 L8.72,10.1444066 C8.514,9.78740658 8.306,9.42440658 8.102,9.06040658 L3,9.06040658 L0,20.4414066 L22,20.4414066 L19.005,9.06040658 Z M1.405,19.3604066 L3.83,10.1474066 L5.852,10.1474066 L5.852,11.7704066 C5.85530371,13.8644049 7.55200163,15.5611029 9.646,15.5644066 L11.272,15.5644066 C13.3659984,15.5677103 15.0626963,17.2644082 15.066,19.3584066 L1.405,19.3604066 Z",
    id: "Path_427",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.362,5.25140658 C13.5683424,4.7704986 13.6859054,4.25620321 13.709,3.73340658 C13.6806404,2.25727719 12.4759018,1.07546183 10.9995,1.07546183 C9.52309822,1.07546183 8.31835959,2.25727719 8.29,3.73340658 C8.31309464,4.25620321 8.43065755,4.7704986 8.637,5.25140658 C9.34031797,6.74418107 10.1289549,8.19524631 10.999,9.59740658 C11.154,9.33940658 11.319,9.06040658 11.575,8.62340658 C12.2336378,7.5340949 12.8299297,6.40828513 13.361,5.25140658 M9.374,3.68840658 C9.374,2.8257378 10.0733312,2.12640658 10.936,2.12640658 C11.7986688,2.12640658 12.498,2.8257378 12.498,3.68840658 C12.498,4.55107535 11.7986688,5.25040658 10.936,5.25040658 C10.0733312,5.25040658 9.374,4.55107535 9.374,3.68840658",
    id: "Path_428",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.364,5.66540658 C14.6235055,5.05256952 14.7688913,4.39748638 14.793,3.73240658 C14.7593728,1.66132576 13.0708538,-3.46944695e-17 10.9995,-3.46944695e-17 C8.9281462,-3.46944695e-17 7.23962725,1.66132576 7.206,3.73240658 C7.23010871,4.39748638 7.37549447,5.05256952 7.635,5.66540658 C8.64539364,7.72949715 9.7684191,9.73652125 10.999,11.6774066 C12.2295809,9.73652125 13.3526064,7.72949715 14.363,5.66540658 M8.29,3.73340658 C8.31835959,2.25727719 9.52309822,1.07546183 10.9995,1.07546183 C12.4759018,1.07546183 13.6806404,2.25727719 13.709,3.73340658 C13.6859156,4.25652704 13.5683547,4.77115235 13.362,5.25240658 C12.6588513,6.74494352 11.8702085,8.19568557 11,9.59740658 C10.129981,8.19557533 9.34134433,6.74484437 8.638,5.25240658 C8.43166628,4.7711455 8.31410629,4.25652408 8.291,3.73340658",
    id: "Path_429",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.936,3.21040658 C11.1999921,3.21040658 11.414,3.42441446 11.414,3.68840658 C11.414,3.95239869 11.1999921,4.16640658 10.936,4.16640658 C10.6720079,4.16640658 10.458,3.95239869 10.458,3.68840658 C10.4585501,3.42464265 10.6722361,3.21095666 10.936,3.21040658 M10.936,2.12640658 C10.0735917,2.12640658 9.37436903,2.82533257 9.37400128,3.68774076 C9.37363381,4.55014896 10.0722604,5.24967008 10.9346684,5.25040659 C11.7970763,5.25114193 12.4968958,4.55281414 12.498,3.69040658 C12.498,2.8277378 11.7986688,2.12840658 10.936,2.12840658",
    id: "Path_430",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceMapIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Device_Map_icon.3eb36dd4be12d303d0fb4b60d8296d89.svg";